import { render, staticRenderFns } from "./ManagerTestsTable.vue?vue&type=template&id=f0652fa0&scoped=true"
import script from "./ManagerTestsTable.vue?vue&type=script&lang=js"
export * from "./ManagerTestsTable.vue?vue&type=script&lang=js"
import style0 from "./ManagerTestsTable.vue?vue&type=style&index=0&id=f0652fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0652fa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VDataTable,VTextField})
